import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, map, take } from 'rxjs';
import { PriceService } from 'src/app/api/services/price.service';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import {
  Formule,
  FormuleApi,
  SaisieFormule,
  SaisieHabitation,
  SaisieInfosSouscripteur
} from 'src/app/core/models/form-state.model';
import { Question } from 'src/app/core/models/question.model';
import { Step } from 'src/app/core/models/step.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import * as fromAddress from 'src/app/core/state/address';
import { AddressState } from 'src/app/core/state/address';
import * as fromContext from 'src/app/core/state/context';
import { State } from 'src/app/core/state/core.state';
import * as fromHousing from 'src/app/core/state/housing';
import * as fromInfo from 'src/app/core/state/info';
import * as fromInsured from 'src/app/core/state/insured';
import * as fromOffer from 'src/app/core/state/offer-customization';
import * as fromPath from 'src/app/core/state/path';
import * as fromService from 'src/app/core/state/service';
import * as fromSubscriber from 'src/app/core/state/subscriber';
import * as fromTarification from 'src/app/core/state/tarification';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { OFFER_CUSTOMIZARION_PATH, ROOT_PATH } from 'src/app/shared/constants/route.constants';
import {
  getMetropoleBaseName,
  getMetropoleClassTwo,
  getMetropoleDisplayName
} from 'src/app/shared/helpers/metropole-helper.service';
import { InsuranceBenefitVM } from 'src/app/shared/models/components/insurancebenefitVm';
import { FormuleRate, rateVM } from 'src/app/shared/models/components/rateVm';
import { PackageCode } from 'src/app/shared/models/enum/packageCode.enum';
import { TypeOfferEnum } from 'src/app/shared/models/enum/typeoffer.enum';
import {
  BaremeValeurAssureeElement,
  ReferenceDataService
} from 'src/app/shared/services/reference-data-service';
import { ApiRequestBodyUtils } from 'src/app/shared/utils/apiRequestBodyUtils';
import { ApiResponseBodyUtils } from 'src/app/shared/utils/apiResponseBodyUtils';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import { isPartner } from 'src/app/shared/utils/brandUtils';
@Component({
  selector: 'app-rate',
  templateUrl: './rate.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RateComponent extends BaseComponent implements OnInit {
  override step: Step = {
    step: isPartner(this.brand) ? this.resource.header.stepQuote : this.resource.header.stepOffer,
    stepNumber: 2,
    subStep: this.resource.header.subStepRate,
    subStepNumber: 3
  };

  override question: Question = {
    libelle: '',
    popupInfo: undefined
  };

  F1!: FormuleRate;
  F2!: FormuleRate;
  rateVM!: rateVM;
  productClass!: string;
  benefitM!: string;
  typeOfferEnum = TypeOfferEnum;
  offerCount!: number;
  hasAnyPromotion: boolean = false;
  isSponsoredPromotion: boolean = false;
  prom: boolean = false;
  promPercentage: number = 0;
  promString!: string;
  promNoDescription: boolean = false;
  iB_CP: boolean = false;
  iB_C: boolean = false;

  insuranceBenefitCPVms: {
    topPart: InsuranceBenefitVM[];
    bottomPart: InsuranceBenefitVM[];
  } = {
    topPart: [],
    bottomPart: []
  };

  insuranceBenefitCVms: {
    topPart: InsuranceBenefitVM[];
    bottomPart: InsuranceBenefitVM[];
  } = {
    topPart: [],
    bottomPart: []
  };

  iB_P: boolean = false;
  insuranceBenefitMVms!: InsuranceBenefitVM[];
  iB_S: boolean = false;
  insuranceBenefitSVms!: InsuranceBenefitVM[];

  typeOffer: string = TypeOfferEnum.C;
  promoForm!: FormGroup;
  path!: PathType;
  context!: string;
  adresse!: AddressState;
  formuleRecommandee!: Formule;
  saisieFormule!: SaisieFormule;
  saisieHabitation!: SaisieHabitation;
  nbRooms!: number;
  bareme!: BaremeValeurAssureeElement;
  FormuleRecommandeeEnum = Formule;
  PathType = PathType;
  isPromoLoading: boolean = false;
  invalidPromoCodeError: boolean = false;
  isAdvisor: boolean = false;
  displayError: boolean = false;
  imgSrc: string = this.resource.rate.buttonPlusPath;
  PromotionCodeError?: string;
  coverageDurationInMonths: number | null = null;
  saisieInfosSouscripteur!: SaisieInfosSouscripteur;
  lessorName: string | null = null;
  offers: FormuleApi[] | undefined;
  get code() {
    return this.promoForm?.get('code')!;
  }

  get sponsorEmail() {
    return this.promoForm?.get('sponsorEmail');
  }

  get brand() {
    return environment.brand;
  }

  constructor(
    private readonly router: Router,
    store: Store<State>,
    resources: AppResource,
    private readonly currencyPipe: CurrencyPipe,
    private readonly priceService: PriceService,
    private readonly refDataService: ReferenceDataService
  ) {
    super(store, resources);
    this.rateVM = new rateVM();
  }

  override async ngOnInit() {
    super.ngOnInit();
    this.updateResumeStepVisibility(false);
    await this.loadStateData();
    this.productClass = getMetropoleClassTwo(this.path) ?? '';
    const displayName = getMetropoleDisplayName(this.path);
    this.benefitM = String.format(this.resource.rate.benefitM, displayName);
    this.getLibelle(this.offerCount);
  }

  private async loadStateData() {
    this.offers = await lastValueFrom(
      this.store.select(fromTarification.selectTarificationFormules).pipe(take(1))
    );
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));
    const context = await lastValueFrom(
      this.store.select(fromContext.selectContextId).pipe(take(1))
    );

    await this.calculatePlafondRessources();

    this.context = context!;

    this.adresse = await lastValueFrom(this.store.select(fromAddress.selectAddress).pipe(take(1)));

    this.hasAnyPromotion = (
      await lastValueFrom(this.store.select(fromTarification.selectTarification).pipe(take(1)))
    ).Tarification.HasAnyPromotion;

    const stateOffer = await lastValueFrom(
      this.store.select(fromOffer.selectOfferCustomization).pipe(take(1))
    );

    this.formuleRecommandee = stateOffer.FormuleRecommandee!;

    this.saisieFormule = stateOffer.SaisieFormule;

    this.saisieHabitation = await lastValueFrom(
      this.store.select(fromHousing.selectHousing).pipe(
        take(1),

        map(s => s.SaisieHabitation)
      )
    );

    this.store.select(fromContext.selectContext).subscribe(res => {
      if (res.contextData != null)
        if (res.contextData?.modeConnexion !== 'COB') {
          this.isAdvisor = true;
        }
    });

    const stateService = await lastValueFrom(
      this.store.select(fromService.selectService).pipe(take(1))
    );

    // get LessorName if
    this.lessorName = stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurPrive
      ?.NomBailleur
      ? stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurPrive?.NomBailleur
      : stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur
      ? stateService.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur
      : null;

    let baremeValeurAssuree = this.refDataService.baremeValeurAssuree;

    if (this.path !== PathType.HOUSING && this.path !== PathType.HOUSING_ETUDIANTE) {
      this.nbRooms = this.saisieHabitation?.NombrePieces ?? 0;
    } else if (this.path === PathType.HOUSING_ETUDIANTE) {
      this.nbRooms = this.saisieHabitation?.NombrePieces ?? 0;
    } else {
      this.nbRooms =
        (this.saisieHabitation?.NombrePieces ?? 0) +
        (this.saisieHabitation?.NombrePiecesSuperieures ?? 0);

      this.bareme = baremeValeurAssuree.find(x => x.NombrePieces == this.nbRooms)!;
    }

    this.initPromoForm();

    let tmpF1 = this.offers?.find(x => x.NomFormule === Formule.F1);
    let tmpF2 = this.offers?.find(x => x.NomFormule === Formule.F2);

    switch (this.path) {
      case PathType.HOUSING:
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.F1);
        tmpF2 = this.offers?.find(x => x.NomFormule === Formule.F2);

        this.offerCount = this.resource.rate.twoOffer;

        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          environment.assConfort
        );

        this.F2 = new FormuleRate(
          tmpF2?.PrimeMensuelle!,
          tmpF2?.PrimeMensuelle!,
          tmpF2?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF2?.PrimeMensuelle!),
          environment.assConfort
        );
        this.getBenefit(TypeOfferEnum.C);
        this.getBenefit(TypeOfferEnum.CP);
        this.iB_CP = true;
        this.iB_C = true;
        break;
      case PathType.HOUSING_PARIS: {
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.PAR);
        this.offerCount = this.resource.rate.oneOffer;

        const productName = getMetropoleBaseName(this.path);
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          String.format(environment.assMetropole, productName)
        );
        this.getBenefit(TypeOfferEnum.P);
        this.iB_P = true;
        break;
      }
      case PathType.HOUSING_TOURCOING: {
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.TOU);
        this.offerCount = this.resource.rate.oneOffer;

        const productName = getMetropoleBaseName(this.path);
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          String.format(environment.assMetropole, productName)
        );
        this.getBenefit(TypeOfferEnum.P);
        this.iB_P = true;
        break;
      }
      case PathType.HOUSING_LILLE: {
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.LIL);
        this.offerCount = this.resource.rate.oneOffer;

        const productName = getMetropoleBaseName(this.path);
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          String.format(environment.assMetropole, productName)
        );
        this.getBenefit(TypeOfferEnum.P);
        this.iB_P = true;
        break;
      }
      case PathType.HOUSING_SOLIDARITY:
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.SOL);

        this.offerCount = this.resource.rate.oneOffer;
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          environment.assSolidaire
        );

        this.getBenefit(TypeOfferEnum.S);
        this.iB_S = true;
        break;
      case PathType.HOUSING_BAILLEURS_SOCIAUX:
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.BSOL);

        this.offerCount = this.resource.rate.oneOffer;
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          environment.assSolidaire
        );

        this.getBenefit(TypeOfferEnum.S);
        this.iB_S = true;
        break;
      case PathType.HOUSING_GRENOBLE:
        {
          tmpF1 = this.offers?.find(x => x.NomFormule === Formule.GRE);
          this.offerCount = this.resource.rate.oneOffer;
          const productName = getMetropoleBaseName(this.path);

          this.F1 = new FormuleRate(
            tmpF1?.PrimeMensuelle!,
            tmpF1?.PrimeMensuelle!,
            tmpF1?.PrimeAnnuelle!,
            this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
            String.format(environment.assMetropole, productName)
          );
          this.getBenefit(TypeOfferEnum.P);
          this.iB_P = true;
        }
        break;
      case PathType.HOUSING_CRETEIL: {
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.CRE);
        this.offerCount = this.resource.rate.oneOffer;

        const productName = getMetropoleBaseName(this.path);
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          String.format(environment.assMetropole, productName)
        );
        this.getBenefit(TypeOfferEnum.P);
        this.iB_P = true;
        break;
      }
      case PathType.HOUSING_MARSEILLE: {
        tmpF1 = this.offers?.find(x => x.NomFormule === Formule.MAR);
        this.offerCount = this.resource.rate.oneOffer;

        const productName = getMetropoleBaseName(this.path);
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          String.format(environment.assMetropole, productName)
        );
        this.getBenefit(TypeOfferEnum.P);
        this.iB_P = true;
        break;
      }
      case PathType.HOUSING_ETUDIANTE:
        {
          tmpF1 = this.offers?.find(x => x.NomFormule === Formule.ETU);
          this.offerCount = this.resource.rate.oneOffer;
          const productName = getMetropoleBaseName(this.path);

          this.F1 = new FormuleRate(
            tmpF1?.PrimeMensuelle!,
            tmpF1?.PrimeMensuelle!,
            tmpF1?.PrimeAnnuelle!,
            this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
            String.format(environment.assMetropole, productName)
          );
          this.getBenefit(TypeOfferEnum.P);
          this.iB_P = true;
        }
        break;
      case PathType.UNDEFINED:
        this.offerCount = this.resource.rate.twoOffer;
        this.F1 = new FormuleRate(
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeMensuelle!,
          tmpF1?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF1?.PrimeMensuelle!),
          environment.assConfort
        );

        this.F2 = new FormuleRate(
          tmpF2?.PrimeMensuelle!,
          tmpF2?.PrimeMensuelle!,
          tmpF2?.PrimeAnnuelle!,
          this.currencyPipe.transform(tmpF2?.PrimeMensuelle!),
          environment.assConfort
        );
        this.getBenefit(TypeOfferEnum.C);
        this.getBenefit(TypeOfferEnum.CP);
        this.iB_CP = true;
        this.iB_C = true;
    }

    this.rateVM.F1 = this.F1;
    this.rateVM.F2 = this.F2;

    if (this.saisieFormule.CodePromo) {
      let promoDescription = await lastValueFrom(
        this.store.select(fromTarification.selectTarificationPromotion).pipe(
          take(1),
          map(p => p?.DetailsPromo)
        )
      );
      this.prom = true;
      this.promString = promoDescription ?? '';
      this.promNoDescription = !promoDescription;
    }

    const isHousingEtudiante = this.path === PathType.HOUSING_ETUDIANTE;
    let saisieInsured = null;
    if (isHousingEtudiante) {
      saisieInsured = await lastValueFrom(
        this.store.select(fromInsured.selectInsured).pipe(take(1))
      );
    }
    this.coverageDurationInMonths = saisieInsured === null ? null : saisieInsured.duration;

    const subscriber = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );
    this.saisieInfosSouscripteur = subscriber.subscriber!;
  }

  initPromoForm() {
    this.promoForm = new FormGroup({
      code: new FormControl<string | null>(null, {
        validators: [Validators.required, this.checkPromoApplied()]
      }),
      sponsorEmail: new FormControl<string | null>('', {
        validators: [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
        ],
        nonNullable: true
      })
    });
  }

  checkPromoApplied(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return this.invalidPromoCodeError ? { promo: {} } : null;
    };
  }

  getLibelle(count: number) {
    if (count === 1) {
      this.store.dispatch(
        fromInfo.updateQuestion({ payload: { libelle: this.resource.question.offer1 } })
      );
    } else {
      this.store.dispatch(
        fromInfo.updateQuestion({
          payload: {
            libelle: String.format(
              this.resource.question.offer2,

              `${this.formuleRecommandee === 'F2' ? '+' : ''}`
            )
          }
        })
      );
    }
  }

  getBenefit(offer: string) {
    switch (offer) {
      case TypeOfferEnum.CP:
        this.insuranceBenefitCPVms.topPart = [
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB1,
            this.resource.insurancebenefit.textB_IB1,
            this.resource.insurancebenefit.text2_IB1,
            '',
            [
              this.resource.insurancebenefit.desc1_IB1,
              this.resource.insurancebenefit.desc2CP_IB1,
              this.resource.insurancebenefit.desc3CP_IB1,
              this.resource.insurancebenefit.desc4CP_IB1,
              this.resource.insurancebenefit.desc5CP_IB1
            ]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB2,
            this.resource.insurancebenefit.textB_IB2,
            this.resource.insurancebenefit.text2_IB2,
            '',
            [this.resource.insurancebenefit.desc1_IB2, this.resource.insurancebenefit.desc2_IB2]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1CP_IB3,
            this.resource.insurancebenefit.text1BCP_IB3,
            this.resource.insurancebenefit.text2CP_IB3,
            this.resource.insurancebenefit.text2BCP_IB3,
            [this.resource.insurancebenefit.desc1_IB3, this.resource.insurancebenefit.desc2CP_IB3]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB4,
            this.resource.insurancebenefit.textB_IB4,
            this.resource.insurancebenefit.text2_IB4,
            '',
            [
              this.resource.insurancebenefit.desc1_IB4,
              this.resource.insurancebenefit.desc2_IB4,
              this.resource.insurancebenefit.desc3_IB4,
              this.resource.insurancebenefit.desc4_IB4,
              this.resource.insurancebenefit.desc5_IB4
            ]
          )
        ];

        this.insuranceBenefitCPVms.bottomPart = [
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB7,
            String.format(
              this.resource.insurancebenefit.textB_IB7,
              this.currencyPipe.transform(this.bareme.F2, 'EUR', 'symbol', '5.0-0', 'fr-FR')
            ),
            '',
            '',
            [
              String.format(
                this.resource.insurancebenefit.descCP1_IB7,
                this.currencyPipe.transform(this.bareme.F2, 'EUR', 'symbol', '5.0-0', 'fr-FR')
              ),
              this.resource.insurancebenefit.descCP2_IB7
            ]
          ),

          new InsuranceBenefitVM(
            '',
            this.resource.insurancebenefit.textB_IB5,
            this.resource.insurancebenefit.text2_IB5,
            '',
            [this.resource.insurancebenefit.desc1_IB5, this.resource.insurancebenefit.desc2_IB5]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB6,
            this.resource.insurancebenefit.textB_IB6,
            '',
            '',
            [this.resource.insurancebenefit.desc1_IB6]
          )
        ];

        break;

      case TypeOfferEnum.C:
        this.insuranceBenefitCVms.topPart = [
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB1,
            this.resource.insurancebenefit.textB_IB1,
            this.resource.insurancebenefit.text2_IB1,
            '',
            [
              this.resource.insurancebenefit.desc1_IB1,
              this.resource.insurancebenefit.desc2CP_IB1,
              this.resource.insurancebenefit.desc3CP_IB1,
              this.resource.insurancebenefit.desc4CP_IB1,
              this.resource.insurancebenefit.desc5CP_IB1
            ]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB2,
            this.resource.insurancebenefit.textB_IB2,
            this.resource.insurancebenefit.text2_IB2,
            '',
            [this.resource.insurancebenefit.desc1_IB2, this.resource.insurancebenefit.desc2_IB2]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1CP_IB3,
            this.resource.insurancebenefit.text1BCP_IB3,
            this.resource.insurancebenefit.text2CP_IB3,
            this.resource.insurancebenefit.text2BCP_IB3,
            [this.resource.insurancebenefit.desc1_IB3, this.resource.insurancebenefit.desc2CP_IB3]
          ),

          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB4,
            this.resource.insurancebenefit.textB_IB4,
            this.resource.insurancebenefit.text2_IB4,
            '',
            [
              this.resource.insurancebenefit.desc1_IB4,
              this.resource.insurancebenefit.desc2_IB4,
              this.resource.insurancebenefit.desc3_IB4,
              this.resource.insurancebenefit.desc4_IB4,
              this.resource.insurancebenefit.desc5_IB4
            ]
          )
        ];

        this.insuranceBenefitCVms.bottomPart = [
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB7,
            String.format(
              this.resource.insurancebenefit.textB_IB7,
              this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
            ),
            '',
            '',
            [
              String.format(
                this.resource.insurancebenefit.descC1_IB7,
                this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
              ),
              this.resource.insurancebenefit.descC2_IB7
            ]
          )
        ];

        break;

      case TypeOfferEnum.P:
        if (this.path === PathType.HOUSING_ETUDIANTE) {
          const lenghtNumber = this.plafondResources.toString().length;
          this.insuranceBenefitMVms = [
            new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB13, '', '', '', [
              this.resource.insurancebenefit.desc1_IB8,
              this.resource.insurancebenefit.desc2_IB8
            ]),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB2,
              this.resource.insurancebenefit.textB_IB2,
              this.resource.insurancebenefit.text2_IB2,
              '',
              [this.resource.insurancebenefit.desc1_IB9, this.resource.insurancebenefit.desc2_IB9]
            ),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1CP_IB3,
              String.format(this.resource.insurancebenefit.text1_IB10, '100'),
              '',
              '',
              [
                this.resource.insurancebenefit.desc1_IB3,
                String.format(this.resource.insurancebenefit.desc2_IB10, '100')
              ]
            ),
            new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB14, '', '', '', [
              this.resource.insurancebenefit.desc2_IB11,
              this.resource.insurancebenefit.desc3_IB11,
              this.resource.insurancebenefit.desc1_IB11
            ]),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB7,
              String.format(
                this.resource.insurancebenefit.textB_IB7,
                this.currencyPipe.transform(
                  this.plafondResources,
                  'EUR',
                  'symbol',
                  `${lenghtNumber}.0-0`,
                  'fr-FR'
                )
              ),
              '',
              '',
              [
                String.format(
                  this.resource.insurancebenefit.descC1_IB7,
                  this.currencyPipe.transform(
                    this.plafondResources,
                    'EUR',
                    'symbol',
                    `${lenghtNumber}.0-0`,
                    'fr-FR'
                  )
                )
              ]
            )
          ];
        } else if (
          this.path !== PathType.HOUSING &&
          this.path !== PathType.HOUSING_SOLIDARITY &&
          this.path !== PathType.HOUSING_BAILLEURS_SOCIAUX
        ) {
          const lenghtNumber = this.plafondResources.toString().length;

          this.insuranceBenefitMVms = [
            new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB8, '', '', '', [
              this.resource.insurancebenefit.desc1_IB8,
              this.resource.insurancebenefit.desc2_IB8
            ]),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB2,
              this.resource.insurancebenefit.textB_IB2,
              this.resource.insurancebenefit.text2_IB2,
              '',
              [this.resource.insurancebenefit.desc1_IB9, this.resource.insurancebenefit.desc2_IB9]
            ),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1CP_IB3,
              String.format(this.resource.insurancebenefit.text1_IB10, '150'),
              '',
              '',
              [
                this.resource.insurancebenefit.desc1_IB3,
                String.format(this.resource.insurancebenefit.desc2_IB10, '150')
              ]
            ),
            new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB11, '', '', '', [
              this.resource.insurancebenefit.desc1_IB11,
              this.resource.insurancebenefit.desc2_IB11,
              this.resource.insurancebenefit.desc3_IB11
            ]),
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB7,
              String.format(
                this.resource.insurancebenefit.textB_IB7,
                this.currencyPipe.transform(
                  this.plafondResources,
                  'EUR',
                  'symbol',
                  `${lenghtNumber}.0-0`,
                  'fr-FR'
                )
              ),
              '',
              '',
              [
                String.format(
                  this.resource.insurancebenefit.desc1_IB12,
                  this.currencyPipe.transform(
                    this.plafondResources,
                    'EUR',
                    'symbol',
                    `${lenghtNumber}.0-0`,
                    'fr-FR'
                  )
                )
              ]
            )
          ];
        } else {
          this.insuranceBenefitMVms = [
            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB1,
              this.resource.insurancebenefit.textB_IB1,
              this.resource.insurancebenefit.text2_IB1,
              '',
              [this.resource.insurancebenefit.desc1_IB1, this.resource.insurancebenefit.desc2_IB1]
            ),

            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB2,
              this.resource.insurancebenefit.textB_IB2,
              this.resource.insurancebenefit.text2_IB2,
              '',
              [this.resource.insurancebenefit.desc1_IB2, this.resource.insurancebenefit.desc2_IB2]
            ),

            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB3,
              this.resource.insurancebenefit.textB_IB3,
              '',
              '',
              [this.resource.insurancebenefit.desc1_IB3, this.resource.insurancebenefit.desc2_IB3]
            ),

            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB4,
              this.resource.insurancebenefit.textB_IB4,
              this.resource.insurancebenefit.text2_IB4,
              '',
              [
                this.resource.insurancebenefit.desc1_IB4,
                this.resource.insurancebenefit.desc2_IB4,
                this.resource.insurancebenefit.desc3_IB4,
                this.resource.insurancebenefit.desc4_IB4,
                this.resource.insurancebenefit.desc5_IB4
              ]
            ),

            new InsuranceBenefitVM(
              this.resource.insurancebenefit.text1_IB7,
              String.format(
                this.resource.insurancebenefit.textB_IB7,
                this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
              ),
              '',
              '',
              [
                String.format(
                  this.resource.insurancebenefit.descC1_IB7,
                  this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
                )
              ]
            )
          ];
        }

        break;

      case TypeOfferEnum.S:
        const lenghtNumber = this.plafondResources.toString().length;

        this.insuranceBenefitSVms = [
          new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB8, '', '', '', [
            this.resource.insurancebenefit.desc1_IB8,
            this.resource.insurancebenefit.desc2_IB8
          ]),
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB2,
            this.resource.insurancebenefit.textB_IB2,
            this.resource.insurancebenefit.text2_IB2,
            '',
            [this.resource.insurancebenefit.desc1_IB9, this.resource.insurancebenefit.desc2_IB9]
          ),
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1CP_IB3,
            String.format(this.resource.insurancebenefit.text1_IB10, '150'),
            '',
            '',
            [
              this.resource.insurancebenefit.desc1_IB3,
              String.format(this.resource.insurancebenefit.desc2_IB10, '150')
            ]
          ),
          new InsuranceBenefitVM(this.resource.insurancebenefit.text1_IB11, '', '', '', [
            this.resource.insurancebenefit.desc1_IB11,
            this.resource.insurancebenefit.desc2_IB11,
            this.resource.insurancebenefit.desc3_IB11
          ]),
          new InsuranceBenefitVM(
            this.resource.insurancebenefit.text1_IB7,
            String.format(
              this.resource.insurancebenefit.textB_IB7,
              this.currencyPipe.transform(
                this.plafondResources,
                'EUR',
                'symbol',
                `${lenghtNumber}.0-0`,
                'fr-FR'
              )
            ),
            '',
            '',
            [
              String.format(
                this.resource.insurancebenefit.desc1_IB12,
                this.currencyPipe.transform(
                  this.plafondResources,
                  'EUR',
                  'symbol',
                  `${lenghtNumber}.0-0`,
                  'fr-FR'
                )
              )
            ]
          )
        ];

        break;

      default:
        break;
    }
  }

  offerSelected(offer: TypeOfferEnum) {
    let ValeurMensuelle = 0;
    let ValeurAnnuelle = 0;
    let FormuleSelectionnee = Formule.F1;

    switch (this.path) {
      case PathType.HOUSING_PARIS:
        FormuleSelectionnee = Formule.PAR;
        break;
      case PathType.HOUSING_LILLE:
        FormuleSelectionnee = Formule.LIL;
        break;
      case PathType.HOUSING_TOURCOING:
        FormuleSelectionnee = Formule.TOU;
        break;
      case PathType.HOUSING_GRENOBLE:
        FormuleSelectionnee = Formule.GRE;
        break;
      case PathType.HOUSING_CRETEIL:
        FormuleSelectionnee = Formule.CRE;
        break;
      case PathType.HOUSING_MARSEILLE:
        FormuleSelectionnee = Formule.MAR;
        break;
      case PathType.HOUSING_SOLIDARITY:
        FormuleSelectionnee = Formule.SOL;
        break;
      case PathType.HOUSING_BAILLEURS_SOCIAUX:
        FormuleSelectionnee = Formule.BSOL;
        break;
      default:
        FormuleSelectionnee = Formule.LM;
        break;
    }

    switch (offer) {
      case TypeOfferEnum.CP:
        ValeurMensuelle = parseFloat(this.F2.rateF.toFixed(2));
        ValeurAnnuelle = this.F2.rateF_Annuel;
        FormuleSelectionnee = Formule.F2;
        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {
              FormuleSelectionnee,
              ValeurMensuelle,
              ValeurAnnuelle
            } as Partial<SaisieFormule>
          })
        );
        break;
      case TypeOfferEnum.C:
        ValeurMensuelle = parseFloat(this.F1.rateF.toFixed(2));
        ValeurAnnuelle = this.F1.rateF_Annuel;
        FormuleSelectionnee = Formule.F1;
        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {
              FormuleSelectionnee,
              ValeurMensuelle,
              ValeurAnnuelle
            } as Partial<SaisieFormule>
          })
        );
        break;
      case TypeOfferEnum.P:
        ValeurMensuelle = parseFloat(this.F1.rateF.toFixed(2));
        ValeurAnnuelle = this.F1.rateF_Annuel;

        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {
              FormuleSelectionnee,
              ValeurMensuelle,
              ValeurAnnuelle
            } as Partial<SaisieFormule>
          })
        );
        break;
      case TypeOfferEnum.S:
        ValeurMensuelle = parseFloat(this.F1.rateF.toFixed(2));
        ValeurAnnuelle = this.F1.rateF_Annuel;
        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {
              FormuleSelectionnee,
              ValeurMensuelle,
              ValeurAnnuelle
            } as Partial<SaisieFormule>
          })
        );
        break;
      default:
        break;
    }

    this.updateStepper();

    this.router.navigate([`${ROOT_PATH}${OFFER_CUSTOMIZARION_PATH}`]);
  }

  plafondResources: number = 0;

  async calculatePlafondRessources() {
    const nbRoomsInStore = await lastValueFrom(
      this.store.select(fromHousing.selectHousing).pipe(take(1))
    );
    let nbRooms =
      (nbRoomsInStore.SaisieHabitation?.NombrePieces ?? 0) +
      (nbRoomsInStore.SaisieHabitation?.NombrePiecesSuperieures ?? 0);

    let baremeValeurAssuree = this.refDataService.getBaremeForMRHMetropoleAltima();

    if (this.path === PathType.HOUSING_ETUDIANTE)
      baremeValeurAssuree = this.refDataService.getBaremeForMRHEtudiant();

    const selected = baremeValeurAssuree.find(x => Number(x.pieceNumber) === nbRooms);
    this.plafondResources = selected!.value;
  }

  async updateRate() {
    this.isPromoLoading = true;
    const codePromoSaisi = this.code.value;
    const SponsorEmailSaisi = this.sponsorEmail?.value;

    // if(this.isSponsoredPromotion && this.sponsorEmail === undefined || this.sponsorEmail?.errors){
    //   this.isPromoLoading = false;
    //   return;
    // }

    // Recreate tarif with the inserted code promo

    let tarifBody = ApiRequestBodyUtils.GenerateTarifCreateRequestBody(
      this.context,
      this.path,
      this.brand,
      this.adresse.adresseType,
      this.adresse.addresseSelection,
      this.adresse.addresseManuelle,
      this.adresse.adresseEsh,
      this.saisieHabitation,
      {
        ...this.saisieFormule,
        CodePromo: codePromoSaisi, // Code promo input
        FormuleSelectionnee: undefined, // Recalculate all formules
        SponsorEmail: SponsorEmailSaisi
      },
      this.formuleRecommandee,
      this.coverageDurationInMonths,
      this.saisieInfosSouscripteur.Email,
      this.lessorName
    );

    // Remove code promo validation error

    this.setCodePromoValidationError(false);

    this.priceService.GetProductPrices(tarifBody).subscribe({
      next: res => {
        this.promString = '';
        this.isSponsoredPromotion = false;

        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {} as Partial<SaisieFormule>
          })
        );

        this.prom = false;
        // Show promotion
        if (res.promotion != null) {
          this.promString = res.promotion?.promotionLabel ?? '';
          this.prom = true;
        }

        // Store returned informations about formules in the state
        const tarifInfos = ApiResponseBodyUtils.ExtractTarifResponseBody(res, this.path);
        this.store.dispatch(
          fromTarification.patchTarification({
            payload: tarifInfos
          })
        );

        // Save promo data in state
        this.store.dispatch(
          fromOffer.patchSaisieFormule({
            payload: {
              CodePromo: codePromoSaisi,
              SponsorEmail: SponsorEmailSaisi
            } as Partial<SaisieFormule>
          })
        );

        // Update VM with new 'formule'
        const packagePrice = res.packages.find(
          pack =>
            pack.code === PackageCode.CONF ||
            pack.code === PackageCode.PARISIENNE ||
            pack.code === PackageCode.TOURQUENNOISE ||
            pack.code === PackageCode.LILLOISE ||
            pack.code === PackageCode.SOLIDAIRE ||
            pack.code === PackageCode.GRENOBLOISE ||
            pack.code === PackageCode.CRISTOLIENNE ||
            pack.code === PackageCode.ETUDIANTE ||
            pack.code === PackageCode.MARSEILLAISE
        );

        const packagePriceConfPlus = res.packages.find(pack => pack.code === PackageCode.CONF_PLUS);
        this.updatePromoRateVM(
          packagePrice?.monthlyPremiumAmountIncludingTax ?? 0,
          packagePriceConfPlus?.monthlyPremiumAmountIncludingTax,
          packagePrice?.annualPremiumAmountIncludingTax ?? 0,
          packagePriceConfPlus?.annualPremiumAmountIncludingTax ?? 0
        );

        // Remove input value
        this.code.reset();
      },

      error: result => {
        this.isPromoLoading = false;

        if (result.status === 404 && result['error']) {
          this.code.reset();
          this.setCodePromoValidationError(true);
          this.PromotionCodeError = result.error.detail;
        } else if (result.status === 422 && result['error']) {
          this.isSponsoredPromotion = true;
        } else if (result.status === 400 && result['error']) {
          this.setCodePromoValidationError(true);
          this.PromotionCodeError = result.error.detail;
          this.isSponsoredPromotion = true;
        } else {
          this.displayError = true;
        }
      },

      complete: () => {
        this.isPromoLoading = false;
      }
    });
  }

  private updatePromoRateVM(
    pricePromoF1: number | undefined,
    pricePromoF2: number | undefined,
    pricePromoF1_Annuel: number,
    pricePromoF2_Annuel: number
  ) {
    if (pricePromoF1 !== undefined) {
      this.F1.rateF = pricePromoF1;
      this.F1.rateF_Annuel = pricePromoF1_Annuel;
      this.F1.rateF_Show = this.currencyPipe.transform(this.F1.rateF);
    }

    if (pricePromoF2 !== undefined) {
      this.F2.rateF = pricePromoF2;
      this.F2.rateF_Annuel = pricePromoF2_Annuel;
      this.F2.rateF_Show = this.currencyPipe.transform(this.F2.rateF);
    }
  }

  private setCodePromoValidationError(isValid: boolean): void {
    this.invalidPromoCodeError = isValid;
    this.promoForm.controls['code'].updateValueAndValidity();
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;
    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.offer
    );
    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.rate
    );
    if (subtitleS) subtitleS.isValid = true;

    let subtitleN = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.offercustomization
    );

    if (subtitleN) subtitleN.isActive = true;
    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  onMouseOver() {
    this.imgSrc = this.resource.rate.buttonPlusColorPath;
  }

  onMouseOut() {
    this.imgSrc = this.resource.rate.buttonPlusPath;
  }

  ToLowerCase(event: any) {
    let value = event.target.value;
    event.target.value = value.toLowerCase();
  }
}
